<template>
  <svg
    class="underwriting-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="80 -880 800 800"
  >
    <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h320v-560H200v560Zm400 0h160v-240H600v240Zm0-320h160v-240H600v240Z" />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'UnderwritingDashboardIcon',
};
</script>

<style lang="scss" scoped>
.underwriting-icon {
  fill: main.$npGray;
}
</style>
